import './App.css';
import RoutesComponent from './components/RoutesComponent';

function App() {
  return (
    <><RoutesComponent /></>
  );
}

export default App;
